import { Component, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { ReplaySubject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { LOCAL_STORAGE_LANG_KEY, AppConstants } from "@core/constants/app";
import { ApplicationService } from "@core/data/application.service";
import { FeatureFlagsService } from "src/app/@core/services/feature-flags.service";

@Component({
    selector: "app-language-selection",
    templateUrl: "./language-selection.component.html",
    standalone: false,
})
export class LanguageSelectionComponent implements OnDestroy {
    readonly translationPrefix = "common.formFieldsLabels";
    languages;
    languageForm: FormGroup;

    private readonly destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

    get languagePicker() {
        return this.languageForm.get("languagePicker");
    }

    constructor(
        private fb: FormBuilder,
        private languageService: TranslateService,
        private router: Router,
        private applicationService: ApplicationService,
        private readonly featureFlags: FeatureFlagsService,
    ) {
        this.languages = this.languageService.getLangs();

        this.languageForm = this.fb.group({
            languagePicker: [localStorage.getItem(LOCAL_STORAGE_LANG_KEY) || null, Validators.required],
        });

        this.languagePicker.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe((lang: string) => this.languageService.use(lang));
    }

    submitSelection() {
        localStorage.setItem(LOCAL_STORAGE_LANG_KEY, this.languagePicker.value);
        this.router.navigate([AppConstants.DASHBOARD_PAGE]);
    }

    ngOnDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
